import React, { createContext, useContext } from "react";
// @ts-expect-error - this will be resolved at build time
import { Box } from "@xsolla/xui-primitives";

export interface RadioGroupContextProps {
  value?: string;
  onChange?: (value: string) => void;
  size?: "sm" | "md" | "lg" | "xl";
  disabled?: boolean;
  testID?: string;
}

const RadioGroupContext = createContext<RadioGroupContextProps>({});

export const useRadioGroup = () => useContext(RadioGroupContext);

export interface RadioGroupProps {
  value?: string;
  onChange?: (value: string) => void;
  size?: "sm" | "md" | "lg" | "xl";
  disabled?: boolean;
  children: React.ReactNode;
  flexDirection?: "row" | "column";
  gap?: number;
  /** Test ID for testing frameworks */
  testID?: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  value,
  onChange,
  size = "md",
  disabled = false,
  children,
  flexDirection = "column",
  gap = 12,
}) => {
  return (
    <RadioGroupContext.Provider value={{ value, onChange, size, disabled }}>
      <Box flexDirection={flexDirection} gap={gap}>
        {children}
      </Box>
    </RadioGroupContext.Provider>
  );
};
